import styled from 'styled-components'
import media from 'styled-media-query'
import PropTypes from 'prop-types'
import React from 'react'
import getID from '../../utils/getCloudinaryID'
import { Helmet } from 'react-helmet'
import Section from '@/components/Section'
import Container from '@/components/Container'
import useDidMount from '../../hooks/useDidMount'
import { getTermHeader } from '../../domain/term/headerMappings/getTermHeader'
import { CustomHeaderType } from '../../domain/term/headerMappings/constants'
import { isLocationInUnitedStates } from '../../domain/location/useCases/isLocationInUnitedStates'
import { getHeroDescription } from '../../domain/hero/getHeroDescription'
import { SIGNIFICANT_CENTER_COUNT } from '../../domain/hero/constants'
import generateCustomHeroCopy from '../../domain/seo/useCases/hero/generateCustomHeroCopy'
import { isLocationPageType } from '../../domain/useCases/pageTypeCheck'
import { getDescriptionToRender } from '../../domain/hero/getDescriptionToRender'

const defaultHeroImage = (didMount = false) =>
  didMount && window.innerWidth > 756
    ? 'https://res.cloudinary.com/rehabpath/image/upload/v1660744275/ds.svg'
    : 'https://res.cloudinary.com/rehabpath/image/upload/v1661375399/a.svg'

const Style = styled.div`
  .header {
    font-size: 42px;
    text-shadow: 0px 0px 8px rgba(0, 0, 0, 0.6);
    color: #ebeaf4;
    line-height: 42px;
    font-weight: 800;
    ${media.lessThan('medium')`
    font-size: 36px;
		`}
  }
  #description {
    /* width: 800px;
    font-style: normal;
    font-weight: 100;
    font-size: 20px;

    ${media.lessThan('medium')`
    font-size: 20px;

        width: 100%;
        a{
          font-size: 20px;
        }
    `}

    line-height: 26px;
    color: white; */
    text-shadow: 0px 0px 4px rgba(0, 0, 0, 0.3);
  }
  .browse-button {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px 16px;
    width: 267px;
    height: 42px;
    background: #ebeaf4;
    border-radius: 6px;
    margin-top: 32px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 140%;
    display: flex;
    align-items: center;
    text-align: center;
    text-decoration: none;
    color: #31279b;
  }
  .location-header {
    font-size: 28px;
    text-align: center;
    margin-bottom: 24px;
    font-weight: 500;
    ${media.lessThan('medium')`
    font-size: 19px;
		`}
  }
  .row {
    display: flex;
    justify-content: start;
    ${media.greaterThan('medium')`
    justify-content: space-around;
		`}
    ${media.lessThan('medium')`
    overflow: hidden;
    overflow-x: auto;
    width: 100%;
    &::-webkit-scrollbar {
      display: none;
    }
		`}
  }
  .txt-shadow {
    text-shadow: 0px 10px 45px rgba(0, 0, 0, 0.8);
  }
  .grad {
    background: linear-gradient(
        273deg,
        rgba(0, 0, 0, 0) 36.2%,
        rgba(0, 1, 2, 0.4) 96.78%
      ),
      linear-gradient(
        273deg,
        rgba(0, 0, 0, 0.4) 36.2%,
        rgba(0, 1, 2, 0.6) 96.78%
      );
  }
  .group {
    margin-top: 80px;
    ${media.lessThan('medium')`
    margin-top: 40px;
		`}
  }
  .arrow-down {
    width: 18px;
    margin-left: 10px;
  }
  .view-all {
    text-align: left !important;
    font-size: 16px !important;
  }
  .hero {
    border-radius: 12px;
    margin: 0 auto;
    overflow: hidden;
    position: relative;

    .overlay {
      width: 100%;
      height: 100%;
      ${media.lessThan('medium')`
      position: absolute;
      top:0;
      `}
      ${(props) =>
        !props.defaultImage
          ? `background: linear-gradient(to bottom, rgba(0, 0, 0, 0.2) 0.30%, rgba(35, 35, 35, ${
              props.overlay || 0.8785
            }));
    `
          : ''}
    }
    .hero-content {
      ${media.lessThan('medium')`
      margin: 0 auto;
      width: 100% ;
      padding: 20px 0;
      `}
      ${media.greaterThan('medium')`
      // max-width: 800px;
      `}
      h1 {
        color: white;
        font-weight: 800;
        line-height: 42px;
      }
    }
    .content {
      ${media.lessThan('medium')`
      padding: 20px 20px;
      align-items: center;
      height: 100%;
      position: relative;
      z-index: 999;
      `}
      padding: 20px 2em 20px 112px;

      display: flex;
      color: white;
      align-items: center;
      justify-content: left;
      position: absolute;
      height: 100%;
      top: 0;
      margin: 0 auto;
      width: 100%;
      p {
        text-align: left;
        color: white;
        font-size: 24px;
        ${media.lessThan('medium')`
        font-size: 16px;
        `}
        margin-top: 10px;
        a {
          text-align: left;
          color: white;
          font-size: 20px;
          margin-top: 10px;
          ${media.lessThan('medium')`
        font-size: 16px;
        line-height: 20px;

        `}
        }
      }
    }
  }
`
const Hero = (props) => {
  const {
    title,
    overlay,
    size,
    background,
    blog,
    count = '',
    pageType,
    secondaryTerm,
    customTitle,
    shouldDefaultRegionalize,
    customTermHeader,
    location,
    term
  } = props
  const didMount = useDidMount()

  const id = getID(background)
  let widths = [1600, 1400, 1200, 1000, 800, 600, 400]
  let height = 400

  const src = `${process.env.GATSBY_CLOUDINARY_PROXY_BASE_URL}/media/upload/w_1600,h_400,q_30,f_auto,c_lfill/${id}`

  const srcSet = widths
    .map(
      (width) =>
        `${process.env.GATSBY_CLOUDINARY_PROXY_BASE_URL}/media/upload/c_lfill,q_30,f_webp,h_${height},w_${width}/${id} ${width}w`
    )
    .join(', ')

  function lowercaseTitle(title) {
    return title ? title.toLowerCase() : ''
  }

  const heroHeader = getTermHeader({
    pageType,
    title,
    termTitle: secondaryTerm,
    customTermHeader,
    headerType: CustomHeaderType.HERO
  })

  const isUSLocation = isLocationInUnitedStates(location)
  const description = getHeroDescription(
    isUSLocation,
    count,
    title,
    shouldDefaultRegionalize
  )

  const parentLocation = location?.parentLocation

  const customHeroCopy = generateCustomHeroCopy({
    term: secondaryTerm,
    customHeroCopy: location?.customHeroCopy || term?.customHeroCopy,
    count,
    location: parentLocation || location?.title,
    pageType
  })

  const copy = {
    Location: {
      title:
        count > 0
          ? `Drug & Alcohol Rehabs in ${title}`
          : `Drug & Alcohol Rehabs near ${title}`,
      description: customHeroCopy || description
    },
    special_consideration: {
      title: `Best ${title} Rehabs`,
      description: `Our independent research team continuously gathers and evaluates data to compile an unbiased and thorough list of the <a style="text-decoration: underline;" href="#browse-all"> ${
        count > SIGNIFICANT_CENTER_COUNT ? count : ''
      } best treatment centers offering ${lowercaseTitle(title)}.`
    },
    activity: {
      title: `Best Rehabs with ${title}`,
      description: `Our independent research team continuously gathers and evaluates data to compile an unbiased and thorough list of the <a style="text-decoration: underline;" href="#browse-all"> ${
        count > SIGNIFICANT_CENTER_COUNT ? count : ''
      } best treatment centers offering ${lowercaseTitle(title)}.`
    },
    accepted_insurance: {
      title: `Best Rehabs with ${title} Insurance Coverage`,
      description: `Our independent research team continuously gathers and evaluates data to compile an unbiased and thorough list of the <a style="text-decoration: underline;" href="#browse-all"> ${
        count > SIGNIFICANT_CENTER_COUNT ? count : ''
      } best treatment centers offering ${lowercaseTitle(title)}.`
    },
    treatment_therapy: {
      title: `Best Rehabs with ${title}`,
      description: `Our independent research team continuously gathers and evaluates data to compile an unbiased and thorough list of the <a style="text-decoration: underline;" href="#browse-all"> ${
        count > SIGNIFICANT_CENTER_COUNT ? count : ''
      } best treatment centers offering ${lowercaseTitle(title)}.`
    },
    treatment_services: {
      title: `Best ${title} Centers`,
      description: `Our independent research team continuously gathers and evaluates data to compile an unbiased and thorough list of the <a style="text-decoration: underline;" href="#browse-all"> ${
        count > SIGNIFICANT_CENTER_COUNT ? count : ''
      } best treatment centers offering ${lowercaseTitle(title)}.`
    },
    amenities: {
      title: `Best Rehabs with ${title}`,
      description: `Our independent research team continuously gathers and evaluates data to compile an unbiased and thorough list of the <a style="text-decoration: underline;" href="#browse-all"> ${
        count > SIGNIFICANT_CENTER_COUNT ? count : ''
      } best treatment centers with ${lowercaseTitle(title)}.`
    },
    setting: {
      title: `Best Rehabs with ${title}`,
      description: `Our independent research team continuously gathers and evaluates data to compile an unbiased and thorough list of the <a style="text-decoration: underline;" href="#browse-all"> ${
        count > SIGNIFICANT_CENTER_COUNT ? count : ''
      } best treatment centers with ${lowercaseTitle(title)}.`
    },
    treatment_method: {
      title: `Best ${title} Rehabs`,
      description: `Our independent research team continuously gathers and evaluates data to compile an unbiased and thorough list of the <a style="text-decoration: underline;" href="#browse-all"> ${
        count > SIGNIFICANT_CENTER_COUNT ? count : ''
      } best treatment centers offering ${lowercaseTitle(title)}.`
    },
    what_we_treat: {
      title: `Best ${title} Rehabs`,
      description: `Our independent research team evaluated the <a style="text-decoration: underline;" href="#browse-all"> ${
        count > SIGNIFICANT_CENTER_COUNT ? count : ''
      } best treatment centers for ${lowercaseTitle(
        title
      )}</a>. Review our curated list of centers offering care options such as virtual, outpatient, and residential treatment. Read unbiased reviews to find the best treatment center for your recovery needs.`
    },
    price: {
      title: `Best ${title} Rehabs`,
      description: `Our independent research team continuously gathers and evaluates data to compile an unbiased and thorough list of the <a style="text-decoration: underline;" href="#browse-all"> ${
        count > SIGNIFICANT_CENTER_COUNT ? count : ''
      } best treatment centers for ${lowercaseTitle(title)}.`
    },
    who_we_treat: {
      title: `Best ${title} Rehabs`,
      description: `Our independent research team continuously gathers and evaluates data to compile an unbiased and thorough list of the <a style="text-decoration: underline;" href="#browse-all"> ${
        count > SIGNIFICANT_CENTER_COUNT ? count : ''
      } best treatment centers for ${lowercaseTitle(title)}.`
    },
    'Location+price': {
      title: `Best ${secondaryTerm} Rehabs in ${title}`,
      description: `<span class='font-semibold'>The best rehab is one that meets your needs.</span> Our independent research team compiled information on the <a style="text-decoration: underline;" href="#browse-all"> ${
        count > SIGNIFICANT_CENTER_COUNT ? count : ''
      } best treatment centers for ${lowercaseTitle(
        secondaryTerm
      )} in ${title}.</a>`
    },
    'Location+what_we_treat': {
      title: `Best ${secondaryTerm} Rehabs in ${title}`,
      description: `Our independent research team evaluated the <a style="text-decoration: underline;" href="#browse-all"> ${
        count > SIGNIFICANT_CENTER_COUNT ? count : ''
      } best treatment centers for ${lowercaseTitle(
        secondaryTerm
      )}</a> in ${title}. Review our curated list of centers offering care options such as virtual, outpatient, and residential treatment. Read unbiased reviews to find the best treatment center for your recovery needs.`
    },
    'Location+who_we_treat': {
      title: `Best ${secondaryTerm} Rehabs in ${title}`,
      description: `<span class='font-semibold'>The best rehab is one that meets your needs.</span> Our independent research team compiled information on the <a style="text-decoration: underline;" href="#browse-all"> ${
        count > SIGNIFICANT_CENTER_COUNT ? count : ''
      } best treatment centers for ${lowercaseTitle(
        secondaryTerm
      )} in ${title}.</a>`
    },
    'Location+accepted_insurance': {
      title: `Best ${title} Rehabs Accepting ${secondaryTerm}`,
      description: `<span class='font-semibold'>The best rehab is one that meets your needs.</span> Our independent research team compiled information on the <a style="text-decoration: underline;" href="#browse-all"> ${
        count > SIGNIFICANT_CENTER_COUNT ? count : ''
      } best treatment centers accepting ${lowercaseTitle(
        secondaryTerm
      )} in ${title}.</a>`
    },
    'Location+special_considerations': {
      title: `Best ${secondaryTerm} Rehabs in ${title}`,
      description: `<span class='font-semibold'>The best rehab is one that meets your needs.</span> Our independent research team compiled information on the <a style="text-decoration: underline;" href="#browse-all"> ${
        count > SIGNIFICANT_CENTER_COUNT ? count : ''
      } best treatment centers offering ${lowercaseTitle(
        secondaryTerm
      )} in ${title}.</a>`
    },
    'Location+amenities': {
      title: `Best ${secondaryTerm} Rehabs in ${title}`,
      description: `<span class='font-semibold'>The best rehab is one that meets your needs.</span> Our independent research team compiled information on the <a style="text-decoration: underline;" href="#browse-all"> ${
        count > SIGNIFICANT_CENTER_COUNT ? count : ''
      } best treatment centers offering ${lowercaseTitle(
        secondaryTerm
      )} in ${title}.</a>`
    },
    'Location+treatment_therapies': {
      title: `Best ${secondaryTerm} Rehabs in ${title}`,
      description: `<span class='font-semibold'>The best rehab is one that meets your needs.</span> Our independent research team compiled information on the <a style="text-decoration: underline;" href="#browse-all"> ${
        count > SIGNIFICANT_CENTER_COUNT ? count : ''
      } best treatment centers offering ${lowercaseTitle(
        secondaryTerm
      )} in ${title}.</a>`
    },
    'Location+treatment_services': {
      title: `Best ${secondaryTerm} Centers in ${title}`,
      description: `<span class='font-semibold'>The best rehab is one that meets your needs.</span> Our independent research team compiled information on the <a style="text-decoration: underline;" href="#browse-all"> ${
        count > SIGNIFICANT_CENTER_COUNT ? count : ''
      } best treatment centers offering ${lowercaseTitle(
        secondaryTerm
      )} in ${title}.</a>`
    },
    'Location+activities': {
      title: `Best ${secondaryTerm} ${title} Centers`,
      description: `<span class='font-semibold'>The best rehab is one that meets your needs.</span> Our independent research team compiled information on the <a style="text-decoration: underline;" href="#browse-all"> ${
        count > SIGNIFICANT_CENTER_COUNT ? count : ''
      } best treatment centers offering ${lowercaseTitle(
        secondaryTerm
      )} in ${title}.</a>`
    },
    'Location+setting': {
      title: `Best ${secondaryTerm} Rehabs in ${title}`,
      description: `<span class='font-semibold'>The best rehab is one that meets your needs.</span> Our independent research team compiled information on the <a style="text-decoration: underline;" href="#browse-all"> ${
        count > SIGNIFICANT_CENTER_COUNT ? count : ''
      } best treatment centers with ${lowercaseTitle(
        secondaryTerm
      )} in ${title}.</a>`
    },
    'Location+treatment_methods': {
      title: `Best ${secondaryTerm} Rehabs in ${title}`,
      description: `<span class='font-semibold'>The best rehab is one that meets your needs.</span> Our independent research team compiled information on the <a style="text-decoration: underline;" href="#browse-all"> ${
        count > SIGNIFICANT_CENTER_COUNT ? count : ''
      } best treatment centers offering ${lowercaseTitle(
        secondaryTerm
      )}</a> in ${title}. Review our curated list to find the best rehab center that meets your needs.`
    }
  }

  const descriptionToRender = getDescriptionToRender(
    copy[pageType],
    pageType,
    term,
    location,
    title,
    secondaryTerm,
    shouldDefaultRegionalize
  )

  return (
    <Style
      overlay={overlay}
      defaultImage={!background}
      size={size}
      blog={blog}
    >
      {copy[pageType] && (
        <>
          <Helmet>
            <link
              rel="preload"
              as="image"
              href={id ? src : defaultHeroImage(didMount)}
              imageSrcSet={id ? srcSet : undefined}
              imageSizes="100vw" // indicate that the image is full-width
            />
          </Helmet>
          <div id="hero">
            <Helmet>
              <link
                rel="preload"
                as="image"
                href={id ? src : defaultHeroImage(didMount)}
                imageSrcSet={id ? srcSet : undefined}
                imageSizes="100vw" // indicate that the image is full-width
              />
            </Helmet>

            <Section>
              <Container size="xl">
                <div className="relative overflow-hidden rounded-xl bg-gray-1100">
                  <img
                    className="h-96 w-full object-cover md:h-72 lg:h-80"
                    src={id ? src : defaultHeroImage(didMount)}
                    srcSet={id ? srcSet : undefined}
                    alt={title}
                    sizes="100vw"
                    fetchpriority="high"
                  />
                  <div
                    className="grad absolute inset-0 flex flex-col
                    justify-center p-8 text-white md:p-12 lg:p-16"
                  >
                    <h1 className="txt-shadow text-3xl font-semibold md:text-4xl">
                      {isLocationPageType(pageType)
                        ? customTitle || copy.Location.title
                        : heroHeader}
                    </h1>
                    <p
                      key={'hero-desc'}
                      dangerouslySetInnerHTML={{
                        __html: descriptionToRender
                      }}
                      className="txt-shadow mt-4 max-w-[760px] text-base text-white md:text-lg"
                      id="description"
                    />
                  </div>
                </div>
              </Container>
            </Section>
          </div>
        </>
      )}
    </Style>
  )
}

Hero.propTypes = {
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  background: PropTypes.string,
  title: PropTypes.string,
  overlay: PropTypes.number,
  blog: PropTypes.bool,
  count: PropTypes.number,
  pageType: PropTypes.string,
  secondaryTerm: PropTypes.string,
  customTitle: PropTypes.string
}

Hero.defaultProps = {
  size: 'medium'
}

export default Hero
